/**
 * 退出登录时统一打"自动登录抑制"标记。
 *
 * 所有 IM（微信 H5、飞书 JSAPI、未来的企微等）的自动登录抑制标记，集中在这里。
 * 任何"用户主动退出登录"的入口（auth.tsx 的 logout、SettingsDialog 的 handleSignOut、
 * OAuth 取消后落回 /login 等）都应调用此函数，避免漏打某个 IM 的标记导致退出后被
 * 自动登录拉回。
 *
 * 注意：仅用于"用户主动登出"。会话自然过期（如 401 自动登出）**不应**调用——
 * 那种情况用户下次进来仍应享受免登。
 */
import { markWechatAutoLoginSuppressed } from './wechat-browser';
import { markFeishuAutoLoginSuppressed } from './feishu-browser';

/** 退出登录时调用：标记所有需要抑制的 IM 自动登录。新增 IM 抑制只需在此处加一行。 */
export function markLogoutSuppressFlags(): void {
  markWechatAutoLoginSuppressed();
  markFeishuAutoLoginSuppressed();
}
